import { render } from "./earningSvg.vue?vue&type=template&id=5bc836f4"
import script from "./earningSvg.vue?vue&type=script&lang=js"
export * from "./earningSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__